import { useInstance } from '@meraki-internal/react-dependency-injection';
import { ICareMapNoteTarget } from '../model/ICareMapNoteTarget';
import { useSubscription } from '@meraki-internal/state';
import { CareMapDrawerPage } from '../../components/CareMapDrawerPage';
import { HistoryViewModel } from '../../support/HistoryViewModel';
import { CareMapDrawerState } from '../../caremap/CareMapDrawerState';
import { FileUploader } from '../generic-notes/attachments/FileUploader';
import { ActiveCaremapNoteCreator } from './ActiveCaremapNoteCreator';
import { useSubscriptionSync } from '../../support/state/useSubscriptionV2';
import { CaremapNotesModelFactory } from '../model/CaremapNotesModelFactory';
import { IonButton } from '@ionic/react';
import { AlertPresenter } from '../../AlertBinder';

export const AddNoteUsingCareMapDrawer: React.FC<{ noteTarget: ICareMapNoteTarget; }> = ({ noteTarget }) => {
    const drawerState = useInstance(CareMapDrawerState);
    useSubscription(() => drawerState);
    const uploader = useInstance(FileUploader);
    useSubscription(() => uploader);
    const alert = useInstance(AlertPresenter);

    const history = useInstance(HistoryViewModel);

    const notesFactory = useInstance(CaremapNotesModelFactory);

    const onDidEnter = () => {
        drawerState.setIsMaskingFocusedCareMap(true);
    };

    const onWillLeave = () => {
        drawerState.setIsMaskingFocusedCareMap(false);
    };

    const noteVM = useSubscriptionSync(() => notesFactory.createFormForNewNote(noteTarget));

    const saveAndClose = async () => {
        if (!noteVM){
            return;
        }
        try {
            await noteVM.save();
            history.back();
        }
        catch (err: any){
            alert.showAndLogError(err);
        }
    };

    return (
        <CareMapDrawerPage
            title="Add Note"
            stretchHeight
            hasBack={false}
            hasClose={false}
            enteredHandler={onDidEnter}
            leavingHandler={onWillLeave}
            data-type="note-editor"
            buttons={(
                <>
                    <IonButton
                        data-type="save-button"
                        disabled={!noteVM.canSave()}
                        onClick={saveAndClose}>Save</IonButton>
                    <IonButton data-type="cancel-button" fill="outline" onClick={() => {
                        history.back();
                    }}>Cancel</IonButton>
                </>
            )}
        >
            <ActiveCaremapNoteCreator noteVM={noteVM} />
        </CareMapDrawerPage>
    );
};
